import Marquee from "react-fast-marquee";
import { Mic, ShieldCheck, Sparkles, Languages, TrendingUp } from "lucide-react";

const ITEMS = [
  { icon: Mic, label: "Voice-First AI Learning" },
  { icon: ShieldCheck, label: "Job Placement Guarantee" },
  { icon: Languages, label: "Learn in Your Mother Tongue" },
  { icon: Sparkles, label: "Built for Rural India" },
  { icon: TrendingUp, label: "Skills That Pay" },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="border-y border-deep-trust-blue/10 bg-deep-trust-blue py-6">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <p className="mb-4 text-center text-xs font-semibold uppercase tracking-[0.25em] text-white/50">
          Presented by Unevo Consultant Pvt. Ltd.
        </p>
      </div>
      <Marquee speed={40} gradient={false} pauseOnHover autoFill>
        {ITEMS.map((it, i) => (
          <div key={i} className="marquee-item mx-8 gap-3 text-white/85">
            <it.icon size={18} className="text-emerald-green" />
            <span className="font-heading text-sm font-semibold tracking-wide">{it.label}</span>
            <span className="ml-8 text-vibrant-orange">/</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
